module.exports = "../fonts/current_position.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/current_position.svg
// module id = 355
// module chunks = 0